<template>
  <el-dialog title="添加" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form size="small" :model="formData" :rules="formRules" ref="form">

      <!--类型-->
      <el-form-item label="类型" prop="type" :label-width="formLabelWidth">
        <el-select v-model="formData.type">
          <el-option :value="item.key_name" :label="item.name" :key="item.key_name" v-for="item in type"></el-option>
        </el-select>
      </el-form-item>

      <!--名称-->
      <el-form-item label="名称" prop="name" :label-width="formLabelWidth">
        <el-input v-model="formData.name" autocomplete="off" placeholder="请输入名称"></el-input>
      </el-form-item>

      <!--年份-->
      <el-form-item label="年份" prop="year" :label-width="formLabelWidth">
        <el-input v-model="formData.year" autocomplete="off" placeholder="请输入年份"></el-input>
        <p class="gray9">类型为真题才需要填写</p>
      </el-form-item>

      <el-form-item label="备注" prop="remark" :label-width="formLabelWidth">
        <el-input type="textarea" v-model="formData.remark" :rows="5" placeholder="请输入备注"></el-input>
      </el-form-item>

      <!--是否显示-->
      <el-form-item label="是否显示" prop="status" :label-width="formLabelWidth">
        <el-radio-group v-model="formData.status">
          <el-radio :label="1">显示</el-radio>
          <el-radio :label="0">隐藏</el-radio>
        </el-radio-group>
      </el-form-item>
      
    </el-form>
    <!--操作按钮-->
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="onSubmit()" :disabled="loading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import ShuatiApi from '@/api/study/shuati.js';
export default {
  data() {
    return {
      /*是否加载中*/
      loading: false,
      /*form表单数据对象*/
      formData: {
        name: '',
        type: '',
        year: '',
        remark: '',
        status: 1,
      },
      /*验证规则*/
      formRules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        type: [{ required: true, message: '请选择类型', trigger: 'blur' }],
      },
      /*左边长度*/
      formLabelWidth: '120px',
      /*是否显示*/
      dialogVisible: false,
    };
  },
  props: {
    open_add: Boolean,
    selectModel: Object,
    type: Object,
  },
  created() {
    this.dialogVisible = this.open_add;
  },
  methods: {
    /*添加*/
    onSubmit() {
      let self = this;
      let params = this.formData;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          ShuatiApi.add(params, true)
            .then(res => {
              if (res.code == 1) {
                self.$message({
                  message: res.msg,
                  type: 'success'
                });
                self.dialogFormVisible(true);
                self.loading = false;
              }
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit('closeDialog', {
          type: 'success',
          openDialog: false
        });
      } else {
        this.$emit('closeDialog', {
          type: 'error',
          openDialog: false
        });
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/study/shuati/part/Add.vue